import React, { useState } from 'react';
import {
	MetadataSummaryLine,
	SummaryLabel,
	SummaryValue,
	ValueWrapper,
	MetadataSummary,
	EditActions,
} from './EditVendorData.styles';
import {
	ApButtonMain,
	ApButtonSecondary,
	ApIcon,
	ApInput,
} from '@alixpartners/ui-components';
import { useEffect } from 'react';

const EditVendorData = props => {
	const {
		updateVendorData,
		onClose,
		setShowSideBar,
		setDeleting,
		setDeleteSeg,
	} = props;
	const [editedOptions, setEditedOptions] = useState([]);
	const [data, setData] = useState(
		props.data.filter(dataObj => dataObj.value !== 99)
	);

	useEffect(
		() => {
			setData(props.data.filter(dataObj => dataObj.value !== 99));
		},
		[props.data]
	);

	const handleLabelChange = (event, value) => {
		const updatedOptions = data.map(
			obj =>
				obj.value === value
					? {
							...obj,
							label: event,
					  }
					: obj
		);

		setData(updatedOptions);

		const editedOption = updatedOptions.find(option => option.value === value);

		if (editedOption) {
			const editedIndex = editedOptions.findIndex(
				eOpt => eOpt.value === editedOption.value
			);

			if (editedIndex !== -1) {
				setEditedOptions(prevEditedOptions => {
					prevEditedOptions[editedIndex].label = editedOption.label;
					return [...prevEditedOptions];
				});
			} else {
				setEditedOptions(prevEditedOptions => [
					...prevEditedOptions,
					editedOption,
				]);
			}
		}
	};

	function addInputField() {
		const getHighestIndex = data => {
			let highest = 0;
			data.forEach(obj => {
				if (obj.value > highest) {
					highest = obj.value;
				}
			});
			return highest;
		};

		setData([...data, { value: getHighestIndex(data) + 1, label: '' }]);
	}

	const deleteSegmentation = seg => {
		setDeleting(true);
		setDeleteSeg(seg);
	};
	const saveSettings = () => {
		updateVendorData(editedOptions);
		onClose(false);
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				height: '80%',
				justifyContent: 'space-between',
			}}
		>
			<MetadataSummary>
				{data.map((segment, index) => {
					if (segment.value !== 99) {
						return (
							<MetadataSummaryLine key={index}>
								<SummaryLabel>{index + 1}.</SummaryLabel>
								<SummaryValue>
									<ValueWrapper>
										<ApInput
											value={segment.label}
											type="text"
											name={segment.value}
											onChange={event =>
												handleLabelChange(event, segment.value)
											}
										/>
									</ValueWrapper>
								</SummaryValue>
								<SummaryLabel>
									<ApIcon
										iconName="delete"
										onClick={() => deleteSegmentation(segment)}
									/>
								</SummaryLabel>
							</MetadataSummaryLine>
						);
					}
					return null;
				})}
			</MetadataSummary>

			<EditActions>
				{data.length < 6 && (
					<ApButtonSecondary onClick={addInputField}>Add Row</ApButtonSecondary>
				)}
				<div style={{ margin: '0 5px 0 0' }}>
					<ApButtonMain
						onClick={saveSettings}
						disabled={editedOptions.length === 0}
					>
						Save
					</ApButtonMain>
				</div>
				<div>
					<ApButtonSecondary
						onClick={() => {
							setShowSideBar(false);
							onClose(false);
						}}
					>
						Close
					</ApButtonSecondary>
				</div>
			</EditActions>
		</div>
	);
};

export default EditVendorData;
